import axios from 'axios';

const CLAVE = 'driza_mozo_sesion';
const CLAVE_DISPOSITIVO = 'driza_mozo_dispositivo';

// El almacenamiento puede fallar (modo privado, datos bloqueados): la app
// sigue andando con la sesión en memoria hasta que se cierre.
let enMemoria = null;
let dispositivoEnMemoria = '';

export const leerSesion = () => {
  try {
    const crudo = window.localStorage.getItem(CLAVE);
    if (crudo) return JSON.parse(crudo);
  } catch (error) {
    // se usa la memoria
  }

  return enMemoria;
};

export const guardarSesion = (sesion) => {
  enMemoria = sesion;

  try {
    window.localStorage.setItem(CLAVE, JSON.stringify(sesion));
  } catch (error) {
    // se queda en memoria
  }
};

export const borrarSesion = () => {
  enMemoria = null;

  try {
    window.localStorage.removeItem(CLAVE);
  } catch (error) {
    // nada que borrar
  }
};

export const leerDispositivo = () => {
  try {
    return window.localStorage.getItem(CLAVE_DISPOSITIVO) || dispositivoEnMemoria;
  } catch (error) {
    return dispositivoEnMemoria;
  }
};

export const guardarDispositivo = (nombre) => {
  dispositivoEnMemoria = nombre;

  try {
    window.localStorage.setItem(CLAVE_DISPOSITIVO, nombre);
  } catch (error) {
    // se queda en memoria
  }
};

export const EVENTO_SESION_CAIDA = 'driza-mozo-sesion-caida';

export const mozoApi = axios.create({
  baseURL: `${window.location.origin}/api/mozo`,
  timeout: 15000,
});

mozoApi.interceptors.request.use((config) => {
  const sesion = leerSesion();

  if (sesion?.token) {
    config.headers.Authorization = `Bearer ${sesion.token}`;
  }

  return config;
});

// Si el servidor dice que la sesión ya no sirve (venció, la cerraron, se
// desactivó al usuario), se limpia y la app vuelve al PIN.
mozoApi.interceptors.response.use(
  (res) => res,
  (err) => {
    const datos = err?.response?.data;

    if (err?.response?.status === 401 && datos?.codigo === 'SESION_INVALIDA') {
      borrarSesion();
      window.dispatchEvent(
        new CustomEvent(EVENTO_SESION_CAIDA, { detail: datos.error || '' })
      );
    }

    return Promise.reject(err);
  }
);

export const mensajeDeError = (err, porDefecto) => {
  if (!err?.response) {
    return 'Sin conexión con el servidor. Revisá el wifi del club.';
  }

  return err.response.data?.error || porDefecto;
};
